import angular from 'angular';
import AllowOnlyScanDirective from './allow-only-scan.directive';

let AllowOnlyScanModule = angular.module('allow-only-scan-module', [])

    .directive('allowOnlyScan', AllowOnlyScanDirective)

    .name;

export default AllowOnlyScanModule;


// WEBPACK FOOTER //
// ./client/app/common/allow-only-scan/index.js